import { mapActions } from "vuex";
import moment from "moment";
const common = {
  watch: {
    $route(to) {
      document.title = to.meta.title + " - Krews" || "Krews";
    },
  },

  methods: {
    ...mapActions(["showSnack", "showOverlayLoader"]),
    showSuccess(message) {
      this.showSnack({
        text: message,
        type: "success",
        timeout: 10000,
      });
    },
    showError(message) {
      this.showSnack({
        text: message,
        type: "error",
        timeout: 10000,
      });
    },
    showInfo(message, timeout) {
      this.showSnack({
        text: message,
        type: "info",
        timeout: timeout == null ? 10000 : timeout,
      });
    },
    showLoader(message) {
      this.showOverlayLoader({
        text: message,
        show: true,
      });
    },
    hideLoader() {
      this.showOverlayLoader({
        text: "",
        show: false,
      });
    },
    downloadFile(response,name) {
      const blob = new Blob([response.data], {
        type: response.data.type,
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      response.headers['content-disposition'];
      let fileName = `${name}_${moment().format(
        'YYYYMMDDHHmmss'
      )}.xlsx`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    errorChecker(error) {
      console.log(error);
      var response = error;
          this.hideLoader();
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknow error occured.";
          this.showError(message);
    }
  },
};

export default common;
